var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","id":_vm.field,"name":_vm.field},on:{"change":_vm.fileSelected}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.chooseFile()}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }